import { Box, Button, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import SYSTEM_DEFICIT from 'common/constants/inventoryLabels';
import { formatQty } from '../utils/bulkLotNdcStatus';
import { warningTextTone, warningTint } from '../utils/warningTone';

/**
 * What Apply will send, once the manual panel has been closed on an added entry. Without it the
 * dialog would show an empty picker and an enabled Apply, with the claim itself nowhere on screen.
 */
const ChangeNdcLotManualSummary = ({ selection, onChange, onRemove }) => (
  <Box
    sx={{
      mt: 2,
      p: 1.5,
      border: '1px solid',
      borderColor: (theme) => warningTint(theme, 0.5),
      borderRadius: 2,
      bgcolor: (theme) => warningTint(theme, 0.06),
    }}
  >
    <Stack direction='row' alignItems='center' spacing={1.5}>
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Typography variant='caption' fontWeight={700} sx={{ color: warningTextTone }}>
          Recorded by hand - {SYSTEM_DEFICIT.toLowerCase()}
        </Typography>
        <Typography variant='body2' sx={{ fontFamily: 'monospace' }}>
          {selection.lotNumber}
        </Typography>
        <Typography variant='caption' color='text.secondary'>
          {'NDC '}
          <Box component='span' sx={{ fontFamily: 'monospace' }}>
            {selection.ndc}
          </Box>
          {' · '}
          {selection.expirationDate ? `BUD ${selection.expirationDate}` : 'no expiration date'}
          {selection.quantity ? ` · qty ${formatQty(selection.quantity)}` : ''}
        </Typography>
      </Box>
      <Button size='small' onClick={onChange}>
        Change
      </Button>
      <Button size='small' onClick={onRemove}>
        Remove
      </Button>
    </Stack>
  </Box>
);

ChangeNdcLotManualSummary.propTypes = {
  selection: PropTypes.shape({
    lotNumber: PropTypes.string,
    ndc: PropTypes.string,
    expirationDate: PropTypes.string,
    quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default ChangeNdcLotManualSummary;
